import React from 'react';
import ABSForm, { IControls } from '../ABSForm';
import { ABSModal } from '../ABSModal';
import classNames from 'classnames';
import { connect } from 'dva';
import ABSMessage from '../ABSMessage';
import _ from 'lodash';
import './index.less';

interface IABSFormModalProps {
  controls: IControls[];
  title?: string;
  labelWidth?: number;
  wrapperWidth?: number;
  width?: number;
  beforeSend?: (values: any) => any;
  actionType: string;
  afterDispatch?: (response: any, values: any) => any;
  dispatch: any;
  destroyOnClose?: boolean;
  okText?: string;
  className?: string;
}

class ABSFormModal extends React.Component<IABSFormModalProps, any> {
  static defaultProps = {
    width: 420
  };

  formRef;
  modal;
  isSend;

  showModal = () => {
    this.modal.show( true );
  };

  closeModal = () => {
    this.modal.show( false );
  };

  onSuccessCallback = () => {
    if (!this.isSend) {
      const form = this.formRef.props.form;
      const { beforeSend, actionType, dispatch, afterDispatch } = this.props;
      return form.validateFields((err, values) => {
        if (!err) {
          this.isSend = true;
          let payload = values;
          if (beforeSend) {
            const p = beforeSend(values);
            payload = p ? p : values;
          }
          dispatch({
            type: actionType,
            payload
          }).then(res => {
            const isSuccess = _.get(res, 'is_success', false);
            if (isSuccess) {
              this.closeModal();
              if (afterDispatch) {
                afterDispatch(res, values);
              } else {
                ABSMessage.success('发送成功');
              }
            } else {
              ABSMessage.error(res);
            }
            this.isSend = false;
          });
        }
      });
    }
    ABSMessage.error('发送中...');
  };

  saveFormRef = formRef => {
    this.formRef = formRef;
  };
  render() {
    const {
      controls,
      title,
      width,
      labelWidth,
      wrapperWidth,
      children,
      destroyOnClose,
      okText,
      className
    } = this.props;
    const clazz = classNames({ noTitleFormMargin: !title }, className);
    return (
      <div className="abs-form-modal">
        {children}
        <ABSModal
          content={
            <ABSForm
              className={clazz}
              controls={controls}
              wrappedComponentRef={this.saveFormRef}
              labelWidth={labelWidth}
              wrapperWidth={wrapperWidth}
              disableTextAreaResize={true}
            />
          }
          title={title}
          width={width!}
          okText={okText!}
          onConfirm={this.onSuccessCallback}
          ref={view => (this.modal = view)}
          destroyOnClose={destroyOnClose}
          wrapClassName="abs-form-modal-wrapper"
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return { dispatch };
};

export default connect(
  null,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ABSFormModal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFormModal/index.tsx